import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormInput from './form-input';
import FormTextArea from './form-textarea';
import FormInputEmail from './form-input-email';
import FormInputDate from './form-input-date';
import FormSelect from './form-select';
import FormCheckbox from './form-checkbox';
import FormInputNumber from './form-input-number';
import FormMultiSelect from './form-multiselect';

const formatMap = {
  string: {
    default: FormInput,
    enum: FormSelect,
    multiple: FormMultiSelect,
    email: FormInputEmail,
    date: FormInputDate,
    text: FormTextArea,
  },
  boolean: {
    default: FormCheckbox,
  },
  integer: {
    default: FormInputNumber,
  },
};

const FormGroup = ({ items, col, layout, submitted }) => {
  const notOneCol = layout !== 'One Column';

  return (
    <Grid
      item
      lg={notOneCol ? (col > 1 ? 6 : false) : false}
      xs={notOneCol ? (col > 1 ? false : 12) : false}
    >
      <Box paddingX={notOneCol ? (col > 1 ? 2 : 0) : 0} my={notOneCol ? 2 : 0}>
        {items
          ? items.map((item) => {
              let RenderedComponent = () => <div />;
              try {
                RenderedComponent = formatMap[item.type][item.format]
                  ? formatMap[item.type][item.format]
                  : formatMap[item.type].default;
              } catch (e) {
                console.warn('FormGroup:RenderComponent', e, item);
              }
              const itemKey = item.title.toLowerCase().replace(/[^\w]/gi, '_');
              return (
                <RenderedComponent
                  item={item}
                  unique={itemKey}
                  key={itemKey}
                  submitted={submitted}
                />
              );
            })
          : null}
      </Box>
    </Grid>
  );
};
export default FormGroup;
